export const ELECTRIC_TYPES = ['FUELTYPE_ELECTRIC', 'FUELTYPE_HYBRID'] as const;
